// The monolith's list_labels encodes these characters so vue-i18n does not
// read them as message syntax (CHAR_MAP, GUEST-15136). Text interpolation
// shows them literally ("info&#64;hotel.com"), so decode them before display.
const LABEL_ENTITIES = {
  '&#64;': '@',
  '&#124;': '|',
  '&#123;': '{',
  '&#125;': '}',
  '&#36;': '$',
};

const LABEL_ENTITY_PATTERN = /&#(?:64|124|123|125|36);/g;

/**
 * Reverses only the list_labels CHAR_MAP entities. Any other entity or markup
 * is left as is, so this is not an HTML decoder.
 * @param {*} value - label text
 * @returns {*} decoded string, or the value unchanged if it is not a string
 */
export function decodeLabelEntities(value) {
  if (typeof value !== 'string') {
    return value;
  }

  return value.replace(
    LABEL_ENTITY_PATTERN,
    (entity) => LABEL_ENTITIES[entity],
  );
}
